/**
 * The `App` function in JavaScript imports the Todo component and renders it within the application.
 * @returns The App component is being returned, which renders the Todo component.
 */
import "./App.css";
import Todo from "./components/Todo";
function App() {
  return (
    <>
      <Todo />
    </>
  );
}
export default App;
